import {
  ListItem,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import { formatDayOfMonthWithDayName } from "@src/appV2/redesign/utils/formatDayOfMonthWithDayName";
import { parseISO } from "date-fns";

interface ListItemShiftDateProps {
  shiftStartDate: string;
  workplaceTimeZone: string | undefined;
}

export function ListItemShiftDate(props: ListItemShiftDateProps) {
  const { shiftStartDate, workplaceTimeZone } = props;

  return (
    <ListItem divider>
      <ListItemIcon iconType="calendar-clock" />
      <ListItemText
        disableTypography
        primary={
          <Text semibold variant="h6" sx={{ textWrap: "balance" }}>
            {formatDayOfMonthWithDayName(parseISO(shiftStartDate), {
              formatDayString: "EEEE",
              timezone: workplaceTimeZone,
            })}
          </Text>
        }
      />
    </ListItem>
  );
}
